(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#shappa-chair-finder #fit-form');
    if (!form) return;

    const choices = [];
    let openChoice = null;

    const close = (choice, returnFocus = false) => {
      if (!choice) return;
      choice.wrap.classList.remove('is-open');
      choice.menu.hidden = true;
      choice.button.setAttribute('aria-expanded', 'false');
      if (openChoice === choice) openChoice = null;
      if (returnFocus) choice.button.focus();
    };

    form.querySelectorAll('select').forEach(select => {
      const label = select.closest('label') || form.querySelector(`label[for="${select.id}"]`);
      const name = [...(label?.childNodes || [])]
        .find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim())
        ?.textContent.trim() || select.name;
      const options = [...select.options].filter(option => !option.disabled);
      const wrap = document.createElement('div');
      wrap.className = 'fit-choice';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'fit-choice__button';
      button.setAttribute('aria-label', name);
      button.setAttribute('aria-haspopup', 'listbox');
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', `${select.id}-choices`);
      button.innerHTML = '<span class="fit-choice__value"></span><svg class="fit-choice__chevron" aria-hidden="true" viewBox="0 0 20 20" fill="none"><path d="m4 7 6 6 6-6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      const menu = document.createElement('ul');
      menu.id = `${select.id}-choices`;
      menu.className = 'fit-choice__menu';
      menu.setAttribute('role', 'listbox');
      menu.setAttribute('aria-label', name);
      menu.hidden = true;
      options.forEach((option, index) => {
        const item = document.createElement('li');
        item.className = 'fit-choice__option';
        item.id = `${select.id}-choice-${index}`;
        item.setAttribute('role', 'option');
        item.tabIndex = -1;
        item.textContent = option.textContent;
        item.addEventListener('click', event => {
          event.preventDefault();
          select.value = option.value;
          select.dispatchEvent(new Event('input', {bubbles: true}));
          select.dispatchEvent(new Event('change', {bubbles: true}));
          close(choice, true);
        });
        menu.append(item);
      });

      wrap.append(button, menu);
      select.after(wrap);
      const required = select.required;
      select.required = false;
      select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');
      select.classList.add('fit-choice__native');

      const choice = {select, wrap, button, menu, options, required};
      choices.push(choice);
      const items = [...menu.children];

      const sync = () => {
        const selected = select.selectedOptions[0];
        button.querySelector('.fit-choice__value').textContent = selected?.textContent || '';
        button.setAttribute('aria-label', `${name}: ${selected?.textContent || ''}`);
        button.classList.toggle('is-placeholder', !select.value);
        items.forEach((item, index) => item.setAttribute('aria-selected', String(options[index].value === select.value)));
        if (select.value) {
          button.removeAttribute('aria-invalid');
          button.removeAttribute('aria-describedby');
          wrap.querySelector('.fit-choice__error')?.remove();
        }
      };
      select.addEventListener('change', sync);
      sync();

      const show = (focusOption = true) => {
        close(openChoice);
        openChoice = choice;
        wrap.classList.add('is-open');
        menu.hidden = false;
        button.setAttribute('aria-expanded', 'true');
        if (focusOption) items[Math.max(0, options.findIndex(option => option.value === select.value))]?.focus();
      };
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        if (openChoice === choice) close(choice);
        else show();
      });
      button.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          show();
          if (event.key === 'ArrowUp') items.at(-1)?.focus();
        } else if (event.key === 'Escape') close(choice);
      });
      menu.addEventListener('keydown', event => {
        const index = items.indexOf(document.activeElement);
        let next = index;
        if (event.key === 'ArrowDown') next = (index + 1) % items.length;
        else if (event.key === 'ArrowUp') next = (index - 1 + items.length) % items.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = items.length - 1;
        else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          document.activeElement.click();
          return;
        } else if (event.key === 'Escape') {
          event.preventDefault();
          close(choice, true);
          return;
        } else if (event.key === 'Tab') {
          close(choice);
          return;
        } else return;
        event.preventDefault();
        items[next]?.focus();
      });
      if (label) {
        label.addEventListener('click', event => {
          if (event.target !== label) return;
          event.preventDefault();
          button.focus();
          show();
        });
      }
    });

    document.addEventListener('pointerdown', event => {
      if (openChoice && !openChoice.wrap.contains(event.target)) close(openChoice);
    });
    document.addEventListener('focusin', event => {
      if (openChoice && !openChoice.wrap.contains(event.target)) close(openChoice);
    });
    form.addEventListener('reset', () => requestAnimationFrame(() => {
      choices.forEach(choice => {
        choice.select.dispatchEvent(new Event('change', {bubbles: true}));
        close(choice);
      });
    }));
    form.addEventListener('submit', event => {
      const missing = choices.find(choice => choice.required && !choice.select.value && !choice.select.disabled);
      if (!missing) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      missing.button.setAttribute('aria-invalid', 'true');
      let error = missing.wrap.querySelector('.fit-choice__error');
      if (!error) {
        error = document.createElement('span');
        error.className = 'fit-choice__error';
        error.id = `${missing.select.id}-error`;
        missing.wrap.append(error);
      }
      error.textContent = `Please choose ${missing.select.name.toLowerCase()}.`;
      missing.button.setAttribute('aria-describedby', error.id);
      missing.button.focus();
    }, true);
  }, {once: true});
})();
